


import XModal from "./XModal.vue";
import DataFilters from "../../utils/DataFilters";
import Helper from "../../utils/Helper";
import AppEventBus from "../../utils/AppEventBus";
import Xapi from "../../utils/xapi";
import Editor from "primevue/editor";
import PdfView from "./pdf/PdfView.vue";
import {get, set} from "idb-keyval";
import Dropdown from "primevue/dropdown";


import sign_xml_template from '!!raw-loader!../../assets/signatureXmlTemplate.xml?raw'

import '../../utils/cryptopro/cp_helper';

const selectCertificate = Symbol('selectCertificate');
const signFile = Symbol('signFile');
const signString = Symbol('signString');
const signXmlString = Symbol('signXmlString');
const signDigitalXml = Symbol('signDigitalXml');

declare global {
  interface Window {
    cadesplugin: any,
    cp: any,
  }
}

export interface mrpoa {
  id: string | number,
  title: string,
  guid?: string,
  is_default?: Boolean,
}

export interface signFileResult {
  sign: string,
  certificate: any,
  comment: string | undefined | null,
  signTypeSelected: string,
  mrpoas?: Array<mrpoa>,
}

export interface signDigitalXmlResult {
  xml: string,
  certificate: any,
  comment: string | undefined | null,
  signTypeSelected: string,
  sign: string,
  mrpoas?: Array<mrpoa>,
}

export enum XmlSignType {
  CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED = 0,
  CADESCOM_XML_SIGNATURE_TYPE_ENVELOPING = 1,
  CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE = 2,
}

export interface selectCertificateProps {
  allowComment?: boolean,
  allowSelectSignType?: boolean,
  addCertificateInfo?: boolean,
  signType?: XmlSignType | number,
  docVisualization?: File,
  mrpoas?: Array<mrpoa>
}

export default {
  name: "CPCertificateSelect",
  components: {XModal, Editor, PdfView, Dropdown},
  mixins: [DataFilters],
  props: {
    showSignProgress: {
      type: Boolean,
      default: true,
    },
    checkCrlWhenGetCertificates: {
      type: Boolean,
      default: true,
    }
  },
  emits: ['certificateSelected'],
  data() {
    return {
      certLoadInProgress: false,
      comment: null,
      signTypeSelected: 'Утверждающая',
      cp_certs: null,
      selectedCert: null as any,
      selectedMrpoa: null,
      filesToSign: null,
      options: Object as selectCertificateProps,
      isInSigningProcess: false,
      mode: selectCertificate, //selectCertificate || signFile
      promiseResolver: null,
      promiseRejecter: null,
      allowComment: false,
      allowSelectSignType: false,
      pdfPage: 1,
      pagesCount: 1,
    }
  },
  mounted() {

    setTimeout(async () => {

      this.initPluginIfNotReady(false);

    }, 100);

  },
  methods: {

    async initPluginIfNotReady(showBlockModal = true) {

      if (window.cp && window.cp.isReady) {
        this.getCerts()
        return;
      }

      if (showBlockModal)
        Xapi.showBlockModal('Инициализация плагина КриптоПРО CSP...', 'info', true, false)

      try {

        console.log('Инициализация плагина КриптоПРО CSP')
        await window.cp.init();
        console.log('Плагин КриптоПРО CSP инициализирован')

        this.getCerts();

      } catch (e) {
        Xapi.xShowModalError({text: e})
      } finally {

        if (showBlockModal)
          Xapi.hideBlockModal();

      }

    },

    async getCerts() {

      console.log('Считываение сертификаторв КриптоПРО CSP')

      this.certLoadInProgress = true

      try {
        window.cp.setCheckCertificateValidWhenParsing(this.checkCrlWhenGetCertificates);
        this.cp_certs = await window.cp.getCertificates();

        let was_serial_number = await get('xComponents');

        this.cp_certs.forEach(item => {
          if (item.serialNumber === was_serial_number?.selectedCertificate) {
            this.selectedCert = item;
          }
        });

        console.log('Считываение сертификаторв КриптоПРО CSP закончено')

      } finally {
        this.certLoadInProgress = false
      }

    },

    async okClicked() {


      if (!this.selectedCert) {
        Xapi.xerror('Выберите сертификат для подписи');
        return;
      }

      set('xComponents', {...await get('xComponents'), selectedCertificate: this.selectedCert?.serialNumber});


      const selectCertificateMethod = async () => {
        await this.$emit('certificateSelected', this.selectedCert);

        if (this.promiseResolver)
          await this.promiseResolver({
            cert: this.selectedCert,
            comment: this.comment,
            signTypeSelected: this.signTypeSelected,
            mrpoa: this.selectedMrpoa
          });
      }

      const signFilesMethod = async () => {

        this.isInSigningProcess = true;

        if (this.showSignProgress)
          Xapi.showBlockModal('Подписание...');

        let bannerCounter = 0

        try {

          let result;

          if (Array.isArray(this.filesToSign)) {

            let allProgress = [];

            result = await Promise.all(this.filesToSign.map((item, index) => {

              if (!((this.filesToSign as any) instanceof File) && typeof this.filesToSign !== 'string')
                throw new Error('Неверный формат данных для подписания. Допускается только File, String, Array.');

              let signed = window.cp.signLargeFile(this.selectedCert, item, percentage => {

                allProgress[index] = percentage

                let totalProgress = allProgress.reduce((previousValue, currentValue) => {
                  return allProgress + currentValue
                });

                totalProgress = Math.ceil(totalProgress / this.filesToSign.length)

                Xapi.showBlockModal('Подписание: ' + totalProgress + '%');
                bannerCounter++

              })

              while (bannerCounter-- > 0)
                Xapi.hideBlockModal();

              return signed;

            }));

          } else if (typeof this.filesToSign === 'string') {
            result = await window.cp.sign(this.selectedCert, this.filesToSign);
          } else if (this.filesToSign instanceof File) {

            result = await window.cp.signLargeFile(this.selectedCert, this.filesToSign, percentage => {
              Xapi.showBlockModal('Подписание: ' + percentage + '%')
              bannerCounter++
            });

            while (bannerCounter-- > 0)
              Xapi.hideBlockModal();


          } else {
            throw new Error('Неверный формат данных для подписания. Допускается только File, String, Array.');
          }

          this.promiseResolver({
            sign: result,
            certificate: Helper.methods.copyObjectByJSON(this.selectedCert),
            comment: this.comment,
            signTypeSelected: this.signTypeSelected,
            mrpoa: this.selectedMrpoa
          } as signFileResult);

          //Xapi.hideBlockModal();

        } catch (e) {
          AppEventBus.emit('xShowModalError', {text: 'Не удалось подписать документ. ' + e.message})
          this.promiseRejecter(e)
        } finally {
          this.mode = selectCertificate;
          this.filesToSign = null;
          this.isInSigningProcess = false;

          while (bannerCounter-- > 0)
            Xapi.hideBlockModal();

          if (this.showSignProgress)
            Xapi.hideBlockModal();
        }

      }

      const signXmlAsString = async () => {

        Xapi.showBlockModal('Подписание...')

        try {
          let xml_sign_type = this.options?.signType ?? window.cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE
          let certs

          let result = await window.cp.signXML(this.selectedCert, this.filesToSign, xml_sign_type);

          if (this.options?.addCertificateInfo === true)
            certs = await window.cp.verifyXmlSigns(result);

          this.promiseResolver({
            xml: result,
            certs: certs,
            comment: this.comment,
            signTypeSelected: this.signTypeSelected,
            mrpoa: this.selectedMrpoa
          });

        } catch (e) {
          AppEventBus.emit('xShowModalError', {text: 'Не удалось подписать документ. ' + e.message})
          this.promiseRejecter(e)
        } finally {
          Xapi.hideBlockModal();
        }

      }

      const signDigitalXmlMethod = async () => {

        Xapi.showBlockModal('Подписание...')

        try {

          const convertDateTime = (dt) => {
            return DataFilters.methods.dateToYMD(Date.parse(dt))
          }

          // Подготовить XML
          const prepareXml = async (xmlIn: string | File) => {

            if (xmlIn instanceof File)
              xmlIn = (await Helper.methods.readFileAsString(xmlIn)) as string

            const innerParser = new DOMParser();
            const signXml = innerParser.parseFromString(sign_xml_template, "text/xml");

            const signatureNode = signXml.documentElement;

            let MainDocXml = innerParser.parseFromString(xmlIn as string, "text/xml");
            const documentData = MainDocXml.evaluate('/*[local-name()="Документ"]/*[local-name()="ДанныеДокумента"]', MainDocXml, null, XPathResult.ANY_TYPE, null)?.iterateNext();

            let ident = ''
            if (documentData.lastChild.nodeType === 3)
              ident = documentData.lastChild.nodeValue //.replace(/(\r\n|\n|\r)/gm, "")

            let totalIdent = ident + ''


            const signsElement = MainDocXml.createElementNS(MainDocXml.documentElement.namespaceURI, 'ПодписиДокумента')
            const signElement = MainDocXml.createElementNS('urn:Adm01-003:MasterDomainMeta:v1.0.0', 'ПодписьДокумента')

            if (documentData.nextSibling) {
              documentData.parentElement.insertBefore(signsElement, documentData.nextSibling)
              documentData.parentElement.insertBefore(MainDocXml.createTextNode(totalIdent), documentData.nextSibling)
            }

            totalIdent = ident + '  '
            signsElement.appendChild(MainDocXml.createTextNode(totalIdent))
            signsElement.appendChild(signElement)
            totalIdent = ident + '    '
            signElement.appendChild(MainDocXml.createTextNode("\r\n"))
            signElement.appendChild(signatureNode)

            let signStatusElement = signElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'СтатусПодписи'))
            signStatusElement.appendChild(MainDocXml.createTextNode(this.signTypeSelected))

            let ukepElement = signElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'СертификатУКЭП'))

            ukepElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'СерийныйНомер'))
            ukepElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'ДатаНачала'))
            ukepElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'ДатаОкончания'))

            let ownerDataElement = ukepElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'ДанныеДержателя'))
            ownerDataElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'Фамилия'))
            ownerDataElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'ИмяОтчество'))
            ownerDataElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'СНИЛС'))
            ownerDataElement.appendChild(MainDocXml.createElementNS(signElement.namespaceURI, 'ИНН'))


            const xmlWithSignatureNode = '<?xml version="1.0" encoding="UTF-8"?>' + "\r\n" + MainDocXml.documentElement.outerHTML

            return {
              MainDocXml: MainDocXml,
              xmlOut: xmlWithSignatureNode,
              signElement: signElement,
              parser: innerParser,
            }

          };

          let {MainDocXml, xmlOut, signElement, parser} = await prepareXml(this.filesToSign)

          let xml_sign_type = this.options?.signType ?? window.cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE
          let certs

          let result = await window.cp.signXML(this.selectedCert, xmlOut, xml_sign_type);

          if (this.options?.addCertificateInfo === true)
            certs = await window.cp.verifyXmlSigns(result);

          // Довставить данные о подписи

          const signedXml = parser.parseFromString(result, "text/xml");

          let docSignNewNode = signedXml.evaluate('/*[local-name()="Документ"]/*[local-name()="ПодписиДокумента"]/*[local-name()="ПодписьДокумента"]', signedXml, null, XPathResult.ANY_TYPE, null)?.iterateNext();
          let docSignUkepNewNode = signedXml.evaluate('/*[local-name()="Документ"]/*[local-name()="ПодписиДокумента"]/*[local-name()="ПодписьДокумента"]/*[local-name()="СертификатУКЭП"]', signedXml, null, XPathResult.ANY_TYPE, null)?.iterateNext();


          signedXml.evaluate('*[local-name()="СерийныйНомер"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(certs[0].cert.serialNumber.toLowerCase()))
          signedXml.evaluate('*[local-name()="ДатаНачала"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(convertDateTime(certs[0].cert.validFrom)))
          signedXml.evaluate('*[local-name()="ДатаОкончания"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(convertDateTime(certs[0].cert.validTo)))
          signedXml.evaluate('*[local-name()="ДанныеДержателя"]/*[local-name()="Фамилия"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(certs[0].cert.subject.person_surname))
          signedXml.evaluate('*[local-name()="ДанныеДержателя"]/*[local-name()="ИмяОтчество"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(certs[0].cert.subject.person_name))
          signedXml.evaluate('*[local-name()="ДанныеДержателя"]/*[local-name()="СНИЛС"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(certs[0].cert.subject.snils))
          signedXml.evaluate('*[local-name()="ДанныеДержателя"]/*[local-name()="ИНН"]', docSignUkepNewNode, null, XPathResult.ANY_TYPE, null).iterateNext().appendChild(signedXml.createTextNode(certs[0].cert.subject.inn))

          if (certs[0].cert.subject.ogrn) {

            let trustDataElement = docSignUkepNewNode.appendChild(signedXml.createElementNS(signElement.namespaceURI, 'ДанныеДоверителя'))
            const RuUrLico = trustDataElement.appendChild(signedXml.createElementNS(signElement.namespaceURI, 'РоссийскоеЮридическоеЛицо'))
            RuUrLico.appendChild(signedXml.createElementNS(signElement.namespaceURI, 'Название')).appendChild(signedXml.createTextNode(certs[0].cert.subject.company))
            RuUrLico.appendChild(signedXml.createElementNS(signElement.namespaceURI, 'ОГРН')).appendChild(signedXml.createTextNode(certs[0].cert.subject.ogrn))
            RuUrLico.appendChild(signedXml.createElementNS(signElement.namespaceURI, 'ИНН')).appendChild(signedXml.createTextNode(certs[0].cert.subject.INNLE))

          }

          if (this.selectedMrpoa?.id) {

            const mrpoaNode = signedXml.createElementNS(signElement.namespaceURI, 'ДоверенностьМЧД')
            mrpoaNode.setAttributeNS(signElement.namespaceURI, 'ИД', 'warrant_' + this.selectedMrpoa.guid + '.' + this.selectedMrpoa.extension)

            const idNode = signedXml.createElementNS(signElement.namespaceURI, 'Идентификатор')
            idNode.appendChild(signedXml.createTextNode(this.selectedMrpoa.guid))
            mrpoaNode.appendChild(idNode)

            if (docSignUkepNewNode.nextSibling) {
              docSignUkepNewNode.nextSibling.insertBefore(mrpoaNode, docSignUkepNewNode.parentNode)
            } else {
              docSignUkepNewNode.parentNode.appendChild(mrpoaNode)
            }

          }

          const mainDocSignDetached = '<?xml version="1.0" encoding="UTF-8"?>' + "\r\n" + (docSignNewNode as Element).outerHTML.trim()
          result = '<?xml version="1.0" encoding="UTF-8"?>' + "\r\n" + (signedXml.documentElement).outerHTML.trim()

          this.promiseResolver({
            xml: result,
            certificate: certs[0].cert,
            comment: this.comment,
            signTypeSelected: this.signTypeSelected,
            sign: mainDocSignDetached,
            mrpoa: this.selectedMrpoa
          } as signDigitalXmlResult);

        } catch (e) {
          AppEventBus.emit('xShowModalError', {text: 'Не удалось подписать документ. ' + e.message})
          this.promiseRejecter(e)
        } finally {
          Xapi.hideBlockModal();
        }

      }

      const signStringMethod = async () => {

        this.promiseResolver({
          sign: await window.cp.sign(this.selectedCert, this.filesToSign),
          certificate: this.selectedCert,
          comment: this.comment,
          signTypeSelected: this.signTypeSelected,
          mrpoa: this.selectedMrpoa,
        });

      }

      switch (this.mode) {

        case selectCertificate:
          await selectCertificateMethod.call(this);
          break;

        case signFile:
          await signFilesMethod.call(this)
          break;

        case signXmlString:
          await signXmlAsString.call(this)
          break;

        case signDigitalXml:
          await signDigitalXmlMethod.call(this)
          break;

        case signString:
          await signStringMethod.call(this)
          break;

      }

      this.hide();

    },

    selectCertificate(options: selectCertificateProps) {

      this.initPluginIfNotReady(true);

      this.options = options

      this.mode = selectCertificate;
      this.show();

      return new Promise((resolve, reject) => {
        this.promiseResolver = resolve
        this.promiseRejecter = reject
      });
    },
    signFiles($files, options: selectCertificateProps) {

      this.initPluginIfNotReady(true);

      this.mode = signFile;
      this.options = options

      if (options?.mrpoas)
        this.selectedMrpoa = options?.mrpoas?.find(item => item.is_default === true) ?? {id: null, title: 'Без МЧД'}

      this.show();

      this.filesToSign = $files;

      return new Promise<signFileResult>((resolve, reject) => {
        this.promiseResolver = resolve
        this.promiseRejecter = reject
      });

    },
    signString($string, options: selectCertificateProps) {

      this.initPluginIfNotReady(true);

      this.mode = signString;
      this.options = options
      this.show();

      this.filesToSign = $string;

      return new Promise((resolve, reject) => {
        this.promiseResolver = resolve
        this.promiseRejecter = reject
      });

    },
    signXmlString(xmlString, options: selectCertificateProps) {

      this.initPluginIfNotReady(true);

      this.mode = signXmlString;
      this.options = options
      this.show();

      this.filesToSign = xmlString

      return new Promise((resolve, reject) => {
        this.promiseResolver = resolve
        this.promiseRejecter = reject
      });

    },
    signDigitalXml(xmlString: string | File, options: selectCertificateProps) {

      this.initPluginIfNotReady(true);

      this.mode = signDigitalXml;
      this.options = options

      if (options?.mrpoas)
        this.selectedMrpoa = options?.mrpoas?.find(item => item.is_default === true) ?? {id: null, title: 'Без МЧД'}

      this.show();

      this.filesToSign = xmlString

      return new Promise<signDigitalXmlResult>((resolve, reject) => {
        this.promiseResolver = resolve
        this.promiseRejecter = reject
      });

    },

    show() {
      this.allowComment = this.options?.allowComment
      this.allowSelectSignType = this.options?.allowSelectSignType
      this.$refs.XModal.show();
    },
    async hide() {

      if (this.promiseResolver)
        this.promiseResolver(null);

      await this.$refs.XModal.hide();
      this.comment = null;
      this.allowComment = false

    },
    _certString(cert) {


      if (!cert || !cert.subject) return '';

      let tmp = [];

      if (cert.subject.person_surname && cert.subject.person_name) {
        tmp.push(cert.subject.person_surname + ' ' + cert.subject.person_name);
      } else {
        if (cert.subject.person_surname) tmp.push(cert.subject.person_surname);
        if (cert.subject.person_name) tmp.push(cert.subject.person_name);
      }


      if (cert.subject.name) tmp.push(cert.subject.name);
      if (cert.serialNumber) tmp.push(cert.serialNumber);


      return tmp.join(', ');

    }

  },
  computed: {

    cp() {
      return window?.cp;
    },
    docVisualizationUrl() {

      if (!this.options.docVisualization)
        return null;

      return URL.createObjectURL(this.options.docVisualization)

    },
    header() {

      switch (this.mode) {
        case selectCertificate:
          return 'Выбор сертификата';
        default:
          return 'Подписание';
      }

    },

    okBtnLabel() {

      switch (this.mode) {
        case selectCertificate:
          return 'Выбрать';
        default:
          return 'Подписать';
      }

    },

  },

}
